export default __webpack_public_path__ + "64410da06ef6ec154396663cf52ceb0f.png";